import PropTypes from "prop-types"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { map, size } from "lodash"
import { Button } from "@mui/material"
import { GroupWork } from "@mui/icons-material"
import "./style.scss"

export default function Accounts({ name, accountsDetails, redirect, isSuperuser, partnersDetails }) {
  const navigate = useNavigate()

  useEffect(() => {
    if (isSuperuser && size(accountsDetails) === 0) {
      navigate("/admin")
    }
  }, [isSuperuser, accountsDetails, navigate])

  const goToAccount = (account) => {
    const redirectPath = redirect ? `/${redirect}` : ""
    navigate(`/${account.alias}${redirectPath}`)
  }

  const goToPartner = (partner) => {
    const redirectPath = redirect ? `/${redirect}` : ""
    window.location = `/partners/${partner.alias}${redirectPath}`
  }

  const logout = () => {
    window.location = "/logout"
  }

  return (<div className="accounts">
    <div className="user-name">{name}</div>
    {!!size(accountsDetails) && <>
      <hr />
      <div className="title">Choose an account</div>
      <ul>
        {map(accountsDetails, (account) =>
          <li key={account.id} onClick={() => goToAccount(account)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" className="logo">
              <path d="M930.616 331.673C830.792 83.723 547.421-35.421 302.691 64.403c-51.522 19.321-93.384 48.302-132.025 80.503l57.962 141.686c28.981-57.962 80.503-106.264 144.906-135.245 144.906-57.962 312.352 9.66 370.314 157.786 57.962 144.906-9.66 312.352-157.786 370.314-64.403 25.761-135.245 25.761-196.428 6.44l125.585 309.132c51.522-3.22 99.824-16.101 148.126-35.421 247.95-99.824 367.094-383.195 267.27-627.925zM244.73 573.182l-3.22-3.22c57.962 35.421 164.226 61.182 260.83 22.541 132.025-54.742 209.308-167.447 173.887-254.39S505.56 222.188 373.535 276.931c-96.604 38.642-154.566 125.585-170.667 193.208L99.824 218.969C0 350.994-28.981 531.321 35.421 692.327c67.623 164.226 212.528 270.491 376.755 296.252L244.729 573.183z" />
            </svg>
            <div>
              <div className="name">{account.name}</div>
              <div className="value">/{account.alias}</div>
            </div>
          </li>,
        )}
      </ul>
    </>}
    {!!size(partnersDetails) && <>
      <hr />
      <div className="title">Choose a partner</div>
      <ul>
        {map(partnersDetails, (partner) =>
          <li key={partner.id} onClick={() => goToPartner(partner)}>
            <GroupWork className="logo" />
            <div>
              <div className="name">{partner.name}</div>
              <div className="value">/partners/{partner.alias}</div>
            </div>
          </li>,
        )}
      </ul>
    </>}
    <Button onClick={logout} variant="contained" color="primary" className="logout">Logout</Button>
  </div>
  )
}

Accounts.propTypes = {
  name: PropTypes.string.isRequired,
  accountsDetails: PropTypes.array,
  isScriptLoaded: PropTypes.bool,
  isScriptLoadSucceed: PropTypes.bool,
  redirect: PropTypes.string,
  isSuperuser: PropTypes.bool,
  partnersDetails: PropTypes.array,
}
